import React from 'react';
import Image from 'react-bootstrap/Image'

const NotFund = () => {
    return (
        <div className="text-center">
            <Image src="https://cdn.dribbble.com/users/1175431/screenshots/6188233/404-error-dribbble-800x600.gif" fluid />
        </div>
    );
};

export default NotFund;